/**
 * Quote
 * Monolithic quoting thingie
 */

/**
 * @section Template
 */

<template>
  <div class="g g--golden btl">
    <article class="g-b g-b--l">
    <fieldset class="form-group" :class="{ 'is-errored': contactInvalid }">
      <legend class="form-legend">Your Info</legend>
      <div class="g bt bl br bb">
        <div class="g-b g-b--2of4">
          <div class="form-pair" :class="{ 'is-errored': !validate('firstName') }">
            <label for="first-name">First Name</label>
            <input @blur="dirtify('firstName')" autocapitalize="words" class="form-letterbox" id="first-name" type="text" v-model="contact.firstName">
            <div class="form-error" v-if="!validate('firstName')">Required</div>
          </div>
        </div>
        <div class="g-b g-b--2of4">
          <div class="form-pair" :class="{ 'is-errored': !validate('lastName') }">
            <label for="last-name">Last Name</label>
            <input @blur="dirtify('lastName')" autocapitalize="words" class="form-letterbox" id="last-name" type="text" v-model="contact.lastName">
            <div class="form-error" v-if="!validate('lastName')">Required</div>
          </div>
        </div>
      </div>
      <div class="form-pair form-field" :class="{ 'is-errored': !validate('email') }">
        <label for="email">Email</label>
        <input @blur="dirtify('email')" class="form-letterbox" id="email" type="email" v-model="contact.email">
        <div class="form-error" v-if="!validate('email')">Required</div>
      </div>
      <div class="form-pair form-field" :class="{ 'is-errored': !validate('verifyEmail') }">
        <label for="email">Verify Email</label>
        <input @blur="dirtify('verifyEmail')" class="form-letterbox" id="verify-email" type="email" v-model="contact.verifyEmail">
        <div class="form-error" v-if="!validate('verifyEmail')">Your email address does not match</div>
      </div>
      <div class="form-pair form-field" :class="{ 'is-errored': !validate('phone') }">
        <label for="phone">Phone&nbsp;</label>
        <input @blur="dirtify('phone')" class="form-letterbox" id="phone" type="tel" v-model="contact.phone">
        <div class="form-error" v-if="!validate('phone')">Required</div>
      </div>
      <div class="form-pair form-field">
        <label for="company">Company Name&nbsp;<small class="tcg">leave blank if you are not a company</small></label>
        <input @blur="dirtify('company')" class="form-letterbox" id="company-name" type="text" v-model="contact.company">
      </div>
      <div class="form-pair form-field" :class="{ 'is-errored': !validate('budget') }">
        <label for="company">Budget&nbsp;<small class="tcg">minimum is typically ${{ budgetMin }}</small></label>
        <div class="input-icon">
          <input @blur="setToTwoDecimalPlaces" class="form-letterbox" id="job-budget" type="text" v-model="project.budget">
          <i>$</i>
        </div>
        <div class="notice notice--l" v-if="project.budget && (isNaN(project.budget))">
          Please enter a number.
        </div>
        <div class="notice notice--l" v-if="project.budget && (project.budget < budgetMin)">
          Looks like you're under our typical minimum dollar amount.
          We’ll still look at the job and get back to you.
        </div>
        <div class="form-warning" v-if="!validate('budget')">Required</div>
      </div>
    </fieldset>
    <fieldset class="form-group" :class="{ 'is-errored': addressInvalid }">
      <legend class="form-legend">Shipping Address</legend>
      <div class="form-pair form-field" :class="{ 'is-errored': !validate('shippingLine1') }">
        <label for="shipping-line1">Line 1</label>
        <input @blur="dirtify('shippingLine1')" autocapitalize="words" class="form-letterbox" id="shipping-line1" type="text" v-model="contact.shippingLine1">
        <div class="form-error" v-if="!validate('shippingLine1')">Required</div>
      </div>
      <div class="form-pair form-field">
        <label for="shipping-line2">Line 2&nbsp;<small class="tcg">(optional)</small></label>
        <input autocapitalize="words" class="form-letterbox" id="shipping-line2" type="text" v-model="contact.shippingLine2">
      </div>
      <div class="g g--fit bl br bb">
        <div class="g-b g-b--min" style="max-width: 118px;">
          <div class="form-pair" :class="{ 'is-errored': !validate('shippingPostalCode') }">
            <label for="shipping-postal-code">Postal Code</label>
            <input @blur="dirtify('shippingPostalCode')" @keyup="zipLookup(contact.shippingPostalCode)" type="text" id="shipping-postal-code" class="form-letterbox" v-model="contact.shippingPostalCode">
            <div class="form-error" v-if="!validate('shippingPostalCode')">Required</div>
          </div>
        </div>
        <div class="g-b g-b--max g-b--b">
          <div class="form-pair" :class="{ 'is-errored': !validate('shippingCity') }">
            <label for="shipping-city">City</label>
            <input @blur="dirtify('shippingCity')" class="form-letterbox" id="shipping-city" type="text" v-model="contact.shippingCity">
            <div class="form-error" v-if="!validate('shippingCity')">Required</div>
          </div>
        </div>
        <div class="g-b g-b--min g-b--b" style="max-width:46px">
          <div class="form-pair" :class="{ 'is-errored': !validate('shippingState') }">
            <label for="shipping-state">State</label>
            <input @blur="dirtify('shippingState')" autocapitalize="characters" class="form-letterbox" id="shipping-state" type="text" v-model="contact.shippingState">
            <div class="form-error" v-if="!validate('shippingState')">Required</div>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset class="form-group">
      <div class="form-pair form-field">
        <input class="form-check" id="is-recurring" type="checkbox" v-model="contact.isRecurring">
        <label for="is-recurring">I will have recurring needs / I need an account (stationer, packing needs, agency, etc.)</label>
      </div>
    </fieldset>
    <fieldset class="form-group">
      <div class="form-pair form-field">
        <input class="form-check" id="requested-call" type="checkbox" v-model="contact.requestedCall">
        <label for="requested-call">I would like someone to call me to discuss</label>
      </div>
    </fieldset>
    <fieldset class="form-group">
      <div class="form-pair form-field">
        <input class="form-check" id="requested-email" type="checkbox" v-model="contact.requestedEmail">
        <label for="requested-email">I would like someone to email me to discuss</label>
      </div>
    </fieldset>
    <v-quote-piece
      :contact="contact"
      :is-submitted="isSubmitted"
      :piece-number="1"
      :piece="project.pieces[0]"
      :print-types="printTypes"
      :project="project"
      :referral-types="referralTypes"
      :remove-piece="removePiece"
      :token="token"
    ></v-quote-piece>

    <div class="tac mt1 mb1">
      <vue-recaptcha
        class="recaptcha"
        @verify="captchaValidated"
        @expired="captchaExpired"
        sitekey="6LeLynUUAAAAALxwrh0W8Ztq5ygA4iunuDs_Rdt9">
      </vue-recaptcha>
    </div>
    <div class="tac mt1 mb1">
      <button type="submit" class="btn btn--l btn--prime" @click="submit" :disabled="isInvalid || isLoading || error" :class="{ 'is-loading': isLoading }">
        <span v-if="isLoading">Loading …</span>
        <span v-else>Save & Finish</span>
      </button>
    </div>
    <div class="notice notice--l" v-if="isInvalid">
      <small>Can’t submit just yet! There are a few more things we need.</small>
    </div>
    <div class="notice notice--l" v-if="error">
      {{ error }}
    </div>
  </article>
  <aside class="g-b g-b--s pr">
    <div class="ma1">
      <h3>Learn This</h3>
      Our processes are different. Do you know spot color?
    </div>
    <v-video>
      <div class="video-thumb video-thumb--l bt" slot="trigger">
        <div class="video-thumb-img tcw">
          <img :src="spotColor" alt="Video: What is Spot Color?">
          <svg class="video-icn icn icn--play" aria-hidden="true" role="img">
            <use :xlink:href="`${icons}#play`"/>
          </svg>
        </div>
        <div class="pt1 pb1 pl1 tck">
          <h3>Sauce 101</h3>
          What is Spot Color?
        </div>
      </div>
      <iframe slot="body" src="https://player.vimeo.com/video/149236522" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </v-video>
    <v-video>
      <div class="video-thumb video-thumb--l bt bb" slot="trigger">
        <div class="video-thumb-img tcw">
          <img :src="fileSetup" alt="Video: File Setup for Spot Color Printing">
          <svg class="video-icn icn icn--play" aria-hidden="true" role="img">
            <use :xlink:href="`${icons}#play`"/>
          </svg>
        </div>
        <div class="pt1 pb1 pl1 tck">
          <h3>Sauce 101</h3>
          File Setup for Spot Color Printing
        </div>
      </div>
      <iframe slot="body" src="https://player.vimeo.com/video/149236526" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </v-video>

  </aside>
</div>
</template>

/**
 * @section Logic
 */

<script>
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

import QuotePiece from './QuotePiece';
import Video from './Video';

import fileSetup from '../assets/images/videos/file-setup.jpg';
import icons from '../assets/images/icons.svg';
import spotColor from '../assets/images/videos/spot-color.jpg';

export default {
  data() {
    return {
      budgetMin: window.env.budgetMin,
      captchaVerified: null,
      contact: {
        company: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        shippingCity: '',
        shippingLine1: '',
        shippingLine2: '',
        shippingPostalCode: '',
        shippingState: '',
        isRecurring: false,
        requestedCall: false,
        requestedEmail: false,
      },
      dirtyFields: [],
      error: null,
      fileSetup,
      icons,
      isLoading: false,
      isSubmitted: false,
      printTypes: [],
      project: {
        budget: '',
        name: '',
        pieces: [],
        referralSource: '',
      },
      referralTypes: [],
      spotColor,
    };
  },

  props: {
    token: String,
  },

  computed: {
    addressInvalid() {
      return !this.validate('shippingCity') ||
        !this.validate('shippingLine1') ||
        !this.validate('shippingPostalCode') ||
        !this.validate('shippingState');
    },

    captchaInvalid() {
      return !this.validate('captcha');
    },

    contactInvalid() {
      return !this.validate('email') ||
        !this.validate('verifyEmail') ||
        !this.validate('firstName') ||
        !this.validate('lastName') ||
        !this.validate('phone');
    },

    detailsInvalid() {
      return !this.validate('budget');
    },

    projectInvalid() {
      return !this.project.name;
    },

    isInvalid() {
      return this.addressInvalid ||
        this.detailsInvalid ||
        this.captchaInvalid ||
        this.projectInvalid ||
        this.contactInvalid;
    },

    projectStringified() {
      return {
        ...this.project,
        pieces: JSON.stringify(this.project.pieces),
      };
    },

  },

  watch: {
    contact: {
      deep: true,
      handler() {
        this.save();
      },
    },

    project: {
      deep: true,
      handler() {
        this.save();
      },
    },
  },

  created() {
    this.printTypes = window.MSPrintTypes;
    this.referralTypes = ['Advertisement', 'Social Media', 'Word of Mouth', 'Conference', 'Returning Client'];

    this.load();
  },

  methods: {
    captchaValidated(response) {
      this.captchaVerified = response;
    },
    captchaExpired() {
      this.captchaVerified = null;
    },

    clearProject() {
      window.localStorage.removeItem('project');
    },

    dirtify(key) {
      if (this.dirtyFields.indexOf(key) === -1) {
        this.dirtyFields.push(key);
      }
    },

    generateContact() {
      return {
        email: '',
        phone: '',
        shippingCity: '',
        shippingLine1: '',
        shippingLine2: '',
        shippingPostalCode: '',
        shippingState: '',
        isRecurring: false,
        requestedCall: false,
        requestedEmail: false,
      };
    },

    generatePiece() {
      return {
        artworks: [],
        artworkStatus: '',
        isValid: false,
        notes: '',
        product: null,
      };
    },

    generateProject() {
      return {
        budget: null,
        name: '',
        pieces: [this.generatePiece()],
        previousOrderNumber: '',
        referralSource: '',
      };
    },

    isDirty(key) {
      if (this.isSubmitted) return true;
      return this.dirtyFields.indexOf(key) !== -1;
    },

    load() {
      const lastLoad = JSON.parse(window.localStorage.getItem('quoteDate')) || Date.now();
      const twoWeeks = 1209600000;
      const goofUp = 1488215113690;
      if (lastLoad <= Date.now() - twoWeeks) this.clearProject();
      if (lastLoad <= goofUp) this.clearProject();

      this.contact = JSON.parse(window.localStorage.getItem('contact')) || this.generateContact();
      this.project = JSON.parse(window.localStorage.getItem('project')) || this.generateProject();
    },

    pieceIsEmpty(pieceNumber) {
      for(var key of Object.keys(this.project.pieces[pieceNumber])) {
        switch(typeof this.project.pieces[pieceNumber][key]) {
          case 'number':
            return false;
            break;
        }
      }
      return true;
    },

    setToTwoDecimalPlaces() {
      this.dirtify('budget');
      if (this.project.budget > 0) {
        this.project.budget = parseFloat(this.project.budget).toFixed(2);
      }
    },

    removePiece(pieceNumber) {
      if (this.pieceIsEmpty(pieceNumber)) return this.project.pieces.splice(pieceNumber, 1);
      if (confirm(`Are you sure you want to remove Piece ${pieceNumber + 1}? This can’t be undone.`)) {
        return this.project.pieces.splice(pieceNumber, 1);
      }
    },

    save() {
      window.localStorage.setItem('contact', JSON.stringify(this.contact));
      window.localStorage.setItem('project', JSON.stringify(this.project));
      window.localStorage.setItem('quoteDate', Date.now());
    },

    submit() {
      this.isSubmitted = true;
      this.error = null;
      if (this.isInvalid) return false;

      this.isLoading = true;

      axios.post('/quote',
        { contact: this.contact, project: this.projectStringified, recaptchaToken: this.captchaVerified},
        { headers: { 'X-CSRF-TOKEN': this.token } },
      ).then((response) => {
        console.log('🎉🎉 Quote submitted! 🎉');
        this.clearProject();
        window.location = response.data.next;
      }).catch((error) => {
        console.log(error);
        this.isLoading = false;
        this.error = error.data.message;
      });
    },

    validate(type) {
      switch (type) {
        case 'email':
        case 'firstName':
        case 'lastName':
        case 'shippingCity':
        case 'shippingLine1':
        case 'shippingLine2':
        case 'shippingPostalCode':
        case 'shippingState':
        case 'phone':
          return this.contact[type] && this.contact[type].length !== 0 || !this.isDirty(type);
          break;

        case 'budget':
          return !this.isDirty(type) ||
            this.isDirty && isNaN(type) && this.project.budget > 0;

        case 'captcha':
          return this.captchaVerified;

        case 'verifyEmail':
          return this.contact.email === this.contact.verifyEmail || !this.isDirty('email');
          break;

        default:
          return true;
      }
    },
    zipLookup(query) {
        if(query.length < 4) return false;
        axios.get(`http://api.zippopotam.us/us/${query}`)
            .then((response) => {
                const city = response.data.places[0]['place name'];
                const state = response.data.places[0]['state abbreviation'];
                this.contact.shippingCity = city;
                this.contact.shippingState = state;
                console.log(`🌎 Found ${query} in ${city}, ${state}`);
            }).catch(() => {
            console.log(`⚠️ Couldn’t find location of ${query}`);
        });
    },
  },
  components: {
    'v-quote-piece': QuotePiece,
    'vue-recaptcha': VueRecaptcha,
    'v-video': Video,
  },
};
</script>



// WEBPACK FOOTER //
// components/Quote.vue